import { useEffect, useRef, useState } from "react";

import { acharBairro, cepUnicoDosBairros, consultarCep, mascararCep, nomeDoBairro, soDigitos, taxaDoBairro } from "./cep";

/**
 * Estado do CEP do formulário: preenche sozinho com o CEP único da cidade e,
 * sem CEP único, consulta o CEP digitado para sugerir rua e bairro.
 * `situacao`: "unico" | "buscando" | "achou" | "so_bairro" | "so_rua" | "nao_achou" | null.
 */
export function useCepEndereco({ endereco, setEndereco, bairros, setTaxaEntrega, ruaRef }) {
  const cepUnico = cepUnicoDosBairros(bairros);
  const [situacao, setSituacao] = useState(cepUnico ? "unico" : null);
  const ultimaConsulta = useRef("");

  const escolherBairro = (b) => {
    if (!b) return;
    setEndereco((e) => ({ ...e, bairro: nomeDoBairro(b), cep: e.cep || mascararCep(b.cep) }));
    setTaxaEntrega(taxaDoBairro(b));
  };

  // CEP único: já entra preenchido e o foco vai direto para a rua.
  useEffect(() => {
    if (!cepUnico) return;
    setSituacao("unico");
    setEndereco((e) => (soDigitos(e.cep) === soDigitos(cepUnico) ? e : { ...e, cep: cepUnico }));
    ruaRef.current?.focus();
  }, [cepUnico]); // eslint-disable-line react-hooks/exhaustive-deps

  const aoDigitarCep = async (valor) => {
    const cep = mascararCep(valor);
    setEndereco((e) => ({ ...e, cep }));
    const d = soDigitos(cep);
    if (d.length !== 8) { setSituacao(null); return; }
    if (ultimaConsulta.current === d) return;
    ultimaConsulta.current = d;

    const bairroDoCep = acharBairro(bairros, { cep: d });
    escolherBairro(bairroDoCep);
    setSituacao("buscando");
    const achado = await consultarCep(d);
    if (ultimaConsulta.current !== d) return; // digitou outro CEP no meio
    if (!achado) { setSituacao(bairroDoCep ? "so_bairro" : "nao_achou"); if (bairroDoCep) ruaRef.current?.focus(); return; }
    setEndereco((e) => ({ ...e, rua: e.rua || achado.rua }));
    const bairroAchado = acharBairro(bairros, { cep: d, nome: achado.bairro });
    escolherBairro(bairroAchado);
    // Bairro do ViaCEP fora do cadastro: o campo não muda, então o selo não
    // pode dizer que o bairro foi preenchido (achado 208).
    setSituacao(bairroAchado ? "achou" : "so_rua");
    ruaRef.current?.focus();
  };

  return { cepUnico, situacao, aoDigitarCep, escolherBairro };
}
